import { createFileRoute } from '@tanstack/react-router';
import { ImportsRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';
import { ImportImportingPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportImportingRoute() {
  return (
    <LastWorkspaceResolver>
      <ImportsRouteView>
        <ImportImportingPage />
      </ImportsRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/setup/importing')({
  validateSearch: validateWizardSearch,
  component: ImportImportingRoute,
});
